import { IMRBaseComponent } from "../../base"

import { IMREditGridPopupController } from "./edit-grid.popup.controller"

//#region Asset Imports

import './edit-grid.popup.scss'
import * as TEMPLATE from './edit-grid.popup.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrEditGridPopup'

export class IMREditGridPopupComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: IMREditGridPopupController,
            template: TEMPLATE
        })
    }
}
